// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationNotes-cls1_Pm_","cls2":"TranslationNotes-cls2__4d TranslationNotes-cls1_Pm_"};